import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { Configuration } from '../../constants/config';

/*
  Generated class for the AuthServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AuthServiceProvider {

    private grant_type: string;
    private client_id: string;
    private ServerWithApiUrl: string;

    constructor(public http: Http, _configuration: Configuration) {
        this.grant_type = _configuration.grant_type;
        this.client_id = _configuration.client_id;
        this.ServerWithApiUrl = _configuration.ServerWithApiUrl;
    }


    /**
     * @Info Auth
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-20
     */
    auth(data) {
        return new Promise(resolve => {

            // We're using Angular HTTP provider to request the data,
            // then on the response, it'll map the JSON data to a parsed JS object.
            // Next, we process the data and resolve the promise with the new data.

            this.http.post(this.ServerWithApiUrl+'Login/validateLogin', data)
                .map(res => res.json())
                .subscribe(data => {
                    // we've got back the raw data, now generate the core schedule data
                    // and save the data for later reference
                    resolve(data);
                }, error=>{
                    resolve({Success: false, Message: "", Error: true, ErrorMessage: "An error has occurred"});
                });


        });
    }

}



// WEBPACK FOOTER //
// ./src/providers/auth-service/auth-service.ts